// Hooks
import { useAuth } from './useAuth';
import { engagePassThrough } from '@/resources/membership-service.resource';

export const useMarketingFunnel = () => {
  const { fetcher, memberData } = useAuth();

  const handleSetEngageTag = (tags) => {
    fetcher(
      engagePassThrough({
        firstName: memberData?.firstName,
        lastName: memberData?.lastName,
        email: memberData?.email,
        phone: memberData?.phone,
        tags: tags,
      })
    ).catch((error) => {
      console.error(error);
    });
  };

  return {
    handleSetEngageTag,
  };
};
